export const PHONES = [
  {label: 'vivo', value: 'vivo'},
  {label: 'oppo', value: 'oppo'},
  {label: '华为', value: '华为'},
  {label: '三星', value: '三星'},
  {label: '荣耀', value: '荣耀'},
  {label: 'iphone', value: 'iphone'},
  {label: '小米', value: '小米'},
  {label: '魅族', value: '魅族'},
  {label: '一加', value: '一加'}
]

// 审核状态
export const AUDIT_STATUS = [
  {label: '投放中', value: 1},
  {label: '审核中', value: 2},
  {label: '未通过', value: 3},
  {label: '已停止', value: 4}
]

// 支付类型
export const SETTLEMENT_TYPES = [
  {label: '合约广告', value: 1}
]

// 年龄段
export const AGES = [
  {label: '全部', value: 0},
  {label: '18岁以下', value: 1},
  {label: '18-24岁', value: 2},
  {label: '25-30岁', value: 3},
  {label: '31-35岁', value: 4},
  {label: '36-40岁', value: 5},
  {label: '40-55岁', value: 6},
  {label: '55岁以上', value: 7}
]

export const SEX_MAP = new Map([
  [0, '男'],
  [1, '女']
])

export const USER_STATUS_MAP = new Map([
  [0, '正常'],
  [1, '注销']
])

export const APP_FORCED_MAP = new Map([
  [0, '否'],
  [1, '是']
])

export const APP_TYPE_MAP = new Map([
  [0, 'IOS'],
  [1, 'ANDROID'],
  [2, 'PC']
])

export const SLIDE_SHOWS_DELETED_STATUS = new Map([
  [0, '正常'],
  [1, '已删除']
])

export const DEL_STATUS = new Map([
  [0, '正常'],
  [1, '已删除']
])

export const FEEDBACK_STATUS = new Map([
  [0, '未处理'],
  [1, '已回复']
])
